const baseFontSize = 13

function getRemValue(px, base = baseFontSize) {
  return `${Math.floor((px / base) * 100) / 100}rem`
}

export default getRemValue
